let notifyFn = null;

export const setGlobalNotifyFn = (fn) => {
    notifyFn = fn;
};

export const notifyGlobalError = (message) => {
    if (notifyFn) {
        notifyFn({
            type: 'error',
            message
        });
    }
};

export const notifyGlobalSuccess = (message) => {
    if (notifyFn) {
        notifyFn({
            type: 'success',
            message
        });
    }
};